<template>
  <div>
    <div
      v-for="media in availableMedia"
      :key="media.field"
      class="row"
    >
      <BaseCheckbox
        v-model="stream[`${media.field}_content`]"
        class="checkbox bold text-uppercase"
        :class="['color-' + media.field]"
        :label="media.label"
      />
    </div>
  </div>
</template>

<script>
import BaseCheckbox from "shared/components/core/forms/BaseCheckbox.vue";
import { getSources } from "shared/helpers/media";

export default {
  name: "UniversalSearchMediaTypeFilter",
  components: {
    BaseCheckbox,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    excludedMedia: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      sources: getSources(),
    };
  },
  computed: {
    stream: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    availableMedia() {
      return this.sources.filter(
        ({ medium }) => !this.excludedMedia.includes(medium)
      );
    },
  },
  mounted() {
    this.sources = getSources();
  },
};
</script>

<style lang="scss" scoped>
.desktop .checkbox {
  margin: 4px 0;
}
</style>
